export const PLAYER_CLASSNAME = 'video-player';
